<template>
    <div
        class="tabs-menu-wrapper"
        :class="{ 'tabs-menu-wrapper--expanded': isMenuOpen }"
    >
        <div
            class="tabs-menu-header"
            :class="{ isMenuOpen }"
            @click="switchMenu"
        >
            <div class="title" v-if="!isMenuOpen">
                <!--                <div class="caret" v-if="slotsHeaders[activeField].submenu">-->
                <!--                    <font-awesome-icon-->
                <!--                        class="icon"-->
                <!--                        icon="angle-left"-->
                <!--                    ></font-awesome-icon>-->
                <!--                </div>-->
                <span>{{ slotsHeaders[activeField].title }}</span>
            </div>
            <div class="title" v-else>Меню</div>
            <div class="angle" v-if="!isMenuOpen">
                <font-awesome-icon
                    class="icon"
                    icon="angle-down"
                ></font-awesome-icon>
            </div>
            <div class="close" v-if="isMenuOpen"></div>
        </div>
        <div class="tabs-menu" v-if="isMenuOpen">
            <div class="shadow-maker" />
            <div class="tabs-menu-content">
                <div
                    class="tab"
                    v-for="(item, index) in slotsHeaders"
                    :key="index"
                    @click="changeField(index)"
                >
                    <div
                        class="tab-wrapper"
                        :class="{ active: index == activeField }"
                    >
                        {{ item.title }}
                        <div class="bullet" v-if="item.bullet">
                            {{ item.bullet }}
                        </div>
                        <div class="submenu-icon" v-if="item.submenu">
                            <font-awesome-icon
                                class="icon"
                                icon="angle-right"
                            ></font-awesome-icon>
                        </div>
                    </div>
                </div>
                <div class="tab logout">
                    <div class="tab-wrapper">
                        <div class="logout-line" @click="signOut">
                            <div class="logout-container">
                                <span class="logout-text"
                                    >Выйти из профиля</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <Button
                    data-voicetext="удалить профиль"
                    outline
                    noborder
                    class="tabs-menu__delete-btn"
                    @click="popupClickHandler"
                    >Удалить профиль</Button
                >
                <DeleteProfilePopup v-model="popupHandler.show" />
            </div>
        </div>

        <div class="tab-content">
            <slot :name="currentSlot"></slot>
        </div>
    </div>
</template>

<script>
import { securityService } from '@/tools/sequrity_service';
import Button from '@/components/UI/Button';
import DeleteProfilePopup from '@/components/account/userCard/DeleteProfilePopup';

export default {
    name: 'TabsMenu',
    data: () => ({
        isMenuOpen: false,
        showDeletePopup: false,
        popupHandler: {
            show: false,
            closeOnlyPopup: true,
        },
    }),
    props: {
        activeField: Number,
        slotsHeaders: Array,
    },
    components: {
        Button,
        DeleteProfilePopup,
    },
    computed: {
        currentSlot() {
            return Object.keys(this.$slots)[this.activeField];
        },
    },
    methods: {
        switchMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        changeField(index) {
            this.$emit('change-field', index);
            this.switchMenu();
        },
        signOut() {
            securityService.signOut();
        },
        popupClickHandler() {
            this.popupHandler.show = true;
        },
    },
    watch: {
        popupHandler: {
            handler(val) {
                if (!val.show) this.isMenuOpen = false;
            },
            deep: true,
        },
        isMenuOpen(v) {
            this.$store.dispatch('setHtmlScroll', !v);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/mrem';
@import '../../styles/rem';
/*activate checkbox regExp in finder of phpStorm*/
/*find      {: ([0-9]*)px}*/
/*replace   {: rem($1);}*/

$tamH: mrem(100);

@mixin custom-scroll-bar {
    &::-webkit-scrollbar {
        height: auto;
        width: 0.3rem;
    }

    &::-webkit-scrollbar-thumb {
        background: #e1e1e1;
        border-radius: 0.3rem;
    }

    &::-webkit-scrollbar-track {
        background: none;
    }
}

.tabs-menu-wrapper {
    &--expanded {
        height: 100vh;
    }

    .tabs-menu-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: mrem(40);
        background: white;
        padding: mrem(8) mrem(16);
        border-top: 1px solid #f7f7f8;
        box-shadow: 0 0.5rem 0.5rem rgba(155, 161, 166, 0.23626);

        &.isMenuOpen {
            width: 100%;
            margin-top: -1px;
            z-index: 10;

            .title {
                margin: 0 auto;
            }
        }

        .title {
            font-style: normal;
            font-weight: 600;
            font-size: mrem(14);
            line-height: mrem(26);
            color: #4663ab;
        }
        .angle {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-size: 5rem;
            font-weight: 600;
            cursor: pointer;

            .icon * {
                color: #4663ab;
            }
        }
        .caret {
            display: inline-block;
            margin-right: 8px;
            align-items: center;
            font-size: 5rem;
            font-weight: 600;
            cursor: pointer;

            .icon * {
                color: #4663ab;
            }
        }

        .close {
            position: absolute;
            right: mrem(16);
            width: mrem(24);
            height: mrem(24);
            background: url('../../assets/images/icons/close-acc-menu.svg')
                no-repeat center;
        }
    }
    .tab-content {
        @include custom-scroll-bar;
        //height: calc(100% - #{$tamH});
        overflow-x: scroll;
    }
}

.tabs-menu-content {
    padding-top: mrem(24);
}

.tabs-menu {
    cursor: pointer;
    width: 100%;
    z-index: 2;
    height: calc(100% - 90px);
    height: 90%;
    background: white;
    overflow-x: scroll;
    position: fixed;
    top: mrem(90);

    .tab {
        font-style: normal;
        font-weight: 600;
        font-size: mrem(14);
        line-height: mrem(26);
        height: mrem(40);
        padding-left: mrem(16);
        padding-right: mrem(16);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        color: #4663ab;
        position: relative;
        margin-bottom: mrem(8);

        .tab-wrapper {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #4663ab;
            padding: mrem(8) mrem(16);
            width: 100%;
            &.active {
                color: white;
                background: #4663ab;
                border-radius: mrem(4);
            }
        }

        .bullet {
            position: absolute;
            z-index: 10;
            width: 1.2rem;
            height: 1.2rem;
            font-size: 0.6rem;
            color: white;
            background: #ef627d;
            border-radius: 50%;
            top: -0.6rem;
            right: -0.6rem;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 rem(1) rem(1) rgba(155, 161, 166, 0.23626);
        }

        .submenu-icon {
            float: right;
        }
    }

    &__delete-btn {
        min-height: mrem(8);
        color: #98a0a9;
        font-weight: normal;
        font-size: mrem(18);
        padding-left: mrem(30);
        padding-right: mrem(30);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-top: mrem(16);
        margin-bottom: mrem(32);
    }
}

.shadow-maker {
    height: 1px;
    box-shadow: 0 0.5rem 0.5rem rgba(155, 161, 166, 0.23626);
}

.logout-line {
    border-bottom: mrem(1) solid #ef627d;
    padding-bottom: mrem(4);

    .logout-container {
        cursor: pointer;
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
    }

    .logout-icon {
        margin-right: mrem(16);
        width: mrem(16);
        height: mrem(16);
        background: url('../../assets/images/logout.png') no-repeat
            center/contain;
    }

    .logout-text {
        font-family: 'Proxima Nova';
        font-style: normal;
        font-weight: 600;
        font-size: mrem(18);
        line-height: mrem(26);
        color: #ef627d;
    }
}
</style>
